module.exports = __webpack_public_path__ + "img/PT14.40a97f94.png";